import { FsnCoord } from '../models/map'

export const FUSION_MAP_BOUNDS: [FsnCoord, FsnCoord, FsnCoord, FsnCoord] = [
  [12.72431, 53.31331],
  [12.76231, 53.31411],
  [12.76391, 53.29781],
  [12.72501, 53.29721],
]

export const FUSION_CENTER: any = [12.744, 53.30445]

export const TENT_INITIAL_POSITION: any = [
  12.738932785000912, 53.30189000011734,
]

export const NE: FsnCoord = [
  FUSION_MAP_BOUNDS[1][0] + 0.001,
  FUSION_MAP_BOUNDS[1][1] + 0.001,
]

export const SW: FsnCoord = [
  FUSION_MAP_BOUNDS[3][0] - 0.001,
  FUSION_MAP_BOUNDS[3][1] - 0.001,
]

export const MAX_NE: FsnCoord = [
  FUSION_MAP_BOUNDS[1][0] + 0.05,
  FUSION_MAP_BOUNDS[1][1] + 0.05,
]
export const MAX_SW: FsnCoord = [
  FUSION_MAP_BOUNDS[3][0] - 0.05,
  FUSION_MAP_BOUNDS[3][1] - 0.05,
]

export const TENT_ICON_KEY = 'tentPosition_2025'
export const NO_BORDER_ACTIVATED_ONCE_KEY = 'noBorderActivatedOnce_2025'
export const TENT_LOCKED_KEY = 'tentLocked_2025'

export const STEPS = 400
